<app-modal-frame
  [headerText]="CONSTANTS.HEADER"
  [leftButton]="getLeftButton"
  [rightButton]="getRightButton"
  (emitLeftClick)="leftButtonClick()"
  (emitRightClick)="rightButtonClick()"
  (emitExit)="onClose()"
>
  <!-- Parent Loaad details -->
  <div class="parent-load-container">
    <span>{{ CONSTANTS.PARENT_ULD }}: </span>
    <span>{{ data.selectedLoad.uldNumber }} </span>
    <span>{{ data.selectedLoad.loadKey }}</span>
  </div>
  <!-- ChildLoad Details -->
  <div class="child-load-container">
    <app-table
      [maxHeight]="20"
      [displayedColumns]="displayedColumn"
      [columns]="COLUMN_CONFIG"
      [data]="tableData"
      #childTable
    >
    </app-table>
  </div>
</app-modal-frame>
